import React, { useEffect } from "react";
import {
  withStyles,
  Dialog,
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  CircularProgress,
  MenuItem,
  Button,
  DialogContent,
  DialogContentText,
  DialogTitle,
  DialogActions,
} from "@material-ui/core";
import clsx from "clsx";
import CloseIcon from "@material-ui/icons/Close";

export default function Confirm({
  name,
  isOpen,
  title,
  icon,
  icon2,
  content,
  onConfirm,
  onCancel,
  confirm,
  cancel,
  classes,
  extentions,
  preStyledContent,
  innerHtmlContent,
  autoFocus,
  showCloseButton,
  onClose,
  showDialogActions = true
}) {
  return (
    <Dialog
      key={name}
      open={isOpen}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      class="dialogBox"
    >
      <DialogTitle className={"dialogTitleBar"} id="alert-dialog-title">
        {icon ? <span class="warningIcon">{icon}</span> : null }
        
        {title}
      {showCloseButton && (
        <Button
        aria-label="Close"
        className={"close"}
        onClick={onClose}
      >
        <CloseIcon  />
      </Button>
      )}
      </DialogTitle>
      {content && (<DialogContent className={"extraPadding prsMessage"}>{icon2 ? <span class="contentIcon greenColor">{icon2}</span> : null }{content}</DialogContent>)}
      {preStyledContent && (<DialogContent className={"extraPadding prsMessage"}>{preStyledContent}</DialogContent>)}
      {innerHtmlContent && (<DialogContent className={"extraPadding prsMessage"}><span dangerouslySetInnerHTML={{__html: innerHtmlContent}}></span></DialogContent>)}
      
     {showDialogActions &&  <DialogActions>
        {onConfirm && confirm && (
          <Button
            class="dialogYesButton"
            onClick={onConfirm}
            color="primary"
            autoFocus={autoFocus}

            className={clsx(
              classes.globalCreateSaveButton,
              classes.clearnaceSaveButton
            )}
          >
            {confirm}
          </Button>
        )}

        {onCancel && cancel && (
          <Button
            class="dialogNoButton"
            className={clsx(
              classes.globalCloseButton
            )}
            onClick={onCancel}
            color="primary"
          >
            {cancel}
          </Button>
        )}

        { extentions && extentions.map(d=>{
          if(d.action && d.text){
              return (
                <Button
                class="dialogNoButton"
                onClick={d.action}
                color="primary"
                key={`${d.text}Action`}
                >
                  {d.text}
                </Button>
              )
            }
        }) }
      </DialogActions>
}
    </Dialog>
  );
}
